import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/Tabs';
import UserManagement from '../components/admin/UserManagement';
import NewsManagement from '../components/admin/NewsManagement';
import UsageAnalytics from '../components/admin/UsageAnalytics';
import SupportTickets from '../components/admin/SupportTickets';
import CouponManagement from '../components/admin/CouponManagement';
import ReportsSection from '../components/admin/ReportsSection';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const Admin: React.FC = () => {
  const [activeTab, setActiveTab] = useState('users');
  const { user } = useAuth();

  // Redirect non-admin users
  if (!user || user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Admin Dashboard</h1>
      
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-8">
          <TabsTrigger value="users" onClick={() => setActiveTab('users')}>
            Users
          </TabsTrigger>
          <TabsTrigger value="news" onClick={() => setActiveTab('news')}>
            News & Updates
          </TabsTrigger>
          <TabsTrigger value="analytics" onClick={() => setActiveTab('analytics')}>
            Usage Analytics
          </TabsTrigger>
          <TabsTrigger value="coupons" onClick={() => setActiveTab('coupons')}>
            Coupons
          </TabsTrigger>
          <TabsTrigger value="support" onClick={() => setActiveTab('support')}>
            Support Tickets
          </TabsTrigger>
          <TabsTrigger value="reports" onClick={() => setActiveTab('reports')}>
            Reports
          </TabsTrigger>
        </TabsList>

        <TabsContent value="users">
          <UserManagement />
        </TabsContent>

        <TabsContent value="news">
          <NewsManagement />
        </TabsContent>

        <TabsContent value="analytics">
          <UsageAnalytics />
        </TabsContent>

        <TabsContent value="coupons">
          <CouponManagement />
        </TabsContent>

        <TabsContent value="support">
          <SupportTickets />
        </TabsContent>

        <TabsContent value="reports">
          <ReportsSection />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Admin;